import type { Session } from '@supabase/supabase-js';

export type AppRole = 'admin' | 'teacher' | 'student';

type SharedSessionTokens = Pick<Session, 'access_token' | 'refresh_token'>;

const websiteBaseUrl =
  process.env.EXPO_PUBLIC_SITE_URL?.replace(/\/$/, '') ?? 'https://mcqgen.com';

export function canAccessRoleAccount(role: AppRole, isActive: boolean) {
  if (role === 'teacher' || role === 'student') {
    return isActive;
  }

  return true;
}

export function getRoleHomePath(role: AppRole) {
  switch (role) {
    case 'admin':
      return '/admin';
    case 'teacher':
      return '/teacher';
    case 'student':
      return '/student';
    default:
      return '/sign-in';
  }
}

export function sanitizeNextPath(next: string | null | undefined, role?: AppRole) {
  if (!next || !next.startsWith('/') || next.startsWith('//')) {
    return role ? getRoleHomePath(role) : null;
  }

  if (!role) {
    return next;
  }

  const roleRoot = `/${role}`;

  if (next === roleRoot || next.startsWith(`${roleRoot}/`)) {
    return next;
  }

  return getRoleHomePath(role);
}

export function getWebsiteSignInUrl(next?: string | null) {
  const signInUrl = new URL('/sign-in', websiteBaseUrl);
  const safeNext = sanitizeNextPath(next);

  if (safeNext) {
    signInUrl.searchParams.set('next', safeNext);
  }

  return signInUrl.toString();
}

export function getWebsiteOnboardingUrl(
  next?: string | null,
  session?: SharedSessionTokens | null
) {
  const onboardingUrl = new URL('/onboarding', websiteBaseUrl);
  const safeNext = sanitizeNextPath(next);

  if (safeNext) {
    onboardingUrl.searchParams.set('next', safeNext);
  }

  if (session?.access_token && session.refresh_token) {
    onboardingUrl.hash = new URLSearchParams({
      access_token: session.access_token,
      refresh_token: session.refresh_token,
    }).toString();
  }

  return onboardingUrl.toString();
}
